export var defaultOptions = {
    scrollwheel: false,
    fullscreenControl: false,
    zoomControl: false,
    draggable: false,
};
